import { type PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/components/AuthProvider";

/**
 * MCP consent must load quickly in an external browser (Cursor OAuth). Skip the full
 * Protected stack (/api/me, labor gates) and only require a Supabase session.
 */
export function McpConsentSessionGate({ children }: PropsWithChildren) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
        <div className="max-w-md rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
          <h1 className="text-lg font-semibold text-slate-900">Loading…</h1>
          <p className="mt-2 text-sm text-slate-600">Checking your hub sign-in.</p>
        </div>
      </div>
    );
  }

  if (!session) {
    const returnTo = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/sign-in?returnTo=${returnTo}`} replace />;
  }

  return children;
}
